import React, { useState, useEffect } from "react";

import { Typography, Form, Tabs } from "antd";

import { FONT } from "constants/index";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import FormNewUserReview from "./reviews-drawer-new-review";
dayjs.extend(customParseFormat);

const FormNewUserReviewMultiple = (props) => {
  const [items, setItems] = useState([]);

  const onCloseList = (id, listClosed) => {
    const listItems = listClosed.filter((item) => item.id != id);

    const itemsData = listClosed
      .filter((item) => item.id != id)
      ?.map((item) => {
        return {
          label: item.name,
          key: item.id,
          children: (
            <FormNewUserReview
              user={item}
              showSprints={true}
              onClose={onCloseList}
              lastReview={item?.lastReview}
              listClosed={listItems}
            />
          ),
        };
      });
    if (itemsData.length == 0) {
      props.onClose();
    }
    setItems(itemsData);
  };

  useEffect(() => {
    const itemsData = props.data?.map((item) => {
      var isEdit = false;
      var editRow = null;
      var editId = null;
      if (item.lastReview != null && props.isEdit) {
        isEdit = props.isEdit;
        editId = item.lastReview.id;
        editRow = item.lastReview;
      }

      return {
        label: item.name,
        key: item.id,
        children: (
          <FormNewUserReview
            user={item}
            showSprints={!isEdit}
            onClose={onCloseList}
            editRow={editRow}
            editId={editId}
            lastReview={item?.lastReview}
            listClosed={props.data}
          />
        ),
      };
    });
    setItems(itemsData);
  }, [props]);

  return (
    <Tabs
      defaultActiveKey="1"
      centered
      size="large"
      style={{ fontFamily: FONT }}
      items={items}
    />
  );
};
export default FormNewUserReviewMultiple;
